// extracted by mini-css-extract-plugin
export default {"cardWrapper":"PersonalInfoList_cardWrapper__Dnmr4","itemTitle":"PersonalInfoList_itemTitle__W0DQs","itemText":"PersonalInfoList_itemText__uGaZC"};